export default {
  mounted() {
    this._dropdownObserver = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) this.hideDropdowns();
    });
    this._dropdownObserver.observe(this.$el);
  },

  beforeDestroy() {
    this._dropdownObserver.disconnect();
  },

  methods: {
    hideDropdowns() {
      this.$refs.dropdown?.hide();
    },
  },
};
